export default __webpack_public_path__ + "static/media/addDocumentIcon.9de8efef.svg";